import { render, staticRenderFns } from "./403.vue?vue&type=template&id=6b2cd38d&lang=pug"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2cd38d')) {
      api.createRecord('6b2cd38d', component.options)
    } else {
      api.reload('6b2cd38d', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=6b2cd38d&lang=pug", function () {
      api.rerender('6b2cd38d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/403.vue"
export default component.exports